import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getRestApiReceiverTourSteps({
	defaultStyles,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	return [
		{
			id: 'http-method',
			selector: '[data-tour="http-method"]',
			content:
				'Required: This is used to set the method that needs to be used to connect to the endpoint created on the Task. The Task uses all standard Http Methods such as GET, POST, PUT etc.',
		},
		{
			id: 'url-suffix',
			selector: '[data-tour="url-suffix"]',
			content:
				'Required: This is used to append a suffix to your base URL to create an endpoint in the environment. Note that the base URL is determined by the environment.',
		},
		{
			id: 'http-url',
			selector: '[data-tour="http-url"]',
			content:
				'Required: This setting cannot be adjusted and is solely used to show the final endpoint after the suffix has been setup.',
		},
		{
			id: 'is-synch',
			selector: '[data-tour="is-synch"]',
			content:
				'The "is Sync" checkbox is used to set whether the task needs to send a response back to the source (Synchronous) vs. not sending a response back to the source (Asynchronous) \n' +
				'When set to True : The API Receiver will keep the connection open to await the response data and send back the response before closing the connection.\n' +
				'When set to False : The API Receiver will send back a delivery response to the source but not a response once all processing has completed.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
